import {
    ConfirmedRequestedGroupMemberTripsFragment,
    GroupMemberProspectDetailsFragment,
} from "generated/graphql";
import { useState } from "react";

type UseEmailSelectionProps = {
    confirmedTravelers?: ConfirmedRequestedGroupMemberTripsFragment[][];
    prospectiveTravelers?: GroupMemberProspectDetailsFragment[];
};

export const useEmailSelection = ({
    confirmedTravelers,
    prospectiveTravelers,
}: UseEmailSelectionProps) => {
    const [selectedEmailsMap, setSelectedEmailsMap] = useState<
        Map<string, string>
    >(new Map());

    const emailsFromConfirmedTravelers = () => {
        if (!confirmedTravelers) {
            return [];
        }
        return confirmedTravelers.flat().map((trip) => trip.customer?.email);
    };
    const emailsFromProspectiveTravelers = () => {
        if (!prospectiveTravelers) {
            return [];
        }
        return prospectiveTravelers.map((traveler) => traveler.email);
    };

    const allEmails = [
        ...emailsFromConfirmedTravelers(),
        ...emailsFromProspectiveTravelers(),
    ].filter((email): email is string => email !== null && email !== undefined);

    const handleCheckboxChange = (
        id: string,
        email: string,
        checked: boolean,
    ) => {
        setSelectedEmailsMap((prev) => {
            const newMap = new Map(prev);
            if (checked) {
                newMap.set(id, email);
            } else {
                newMap.delete(id);
            }
            return newMap;
        });
    };
    return { selectedEmailsMap, allEmails, handleCheckboxChange };
};
